import TableContent from './TableContent'

export default TableContent



// WEBPACK FOOTER //
// ./src/views/Content/components/TableContent/index.js